@if (showField$ | async) {
  <mat-form-field>
    <mat-chip-grid #chipList>
      @for (str of currentStrings(); track str) {
        <mat-chip-row
          removable="true" (removed)="remove(str)">
          {{str}}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
      <input [placeholder]="field.placeholder"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="add($event)" />
    </mat-chip-grid>
    @if (showDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !showDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
